import megatron from 'megatron';

export const getCancellationPolicyData = ({url}) => {
  const headers = {
    
  };
  const type = 'GET';
  const credentials = 'include';
  const name = 'hotels room cancellation policy api'
  return megatron({
      url,
      name,
      type,
      headers,
      credentials
  });
}
